import axios from "axios";
import { getField, updateField } from "vuex-map-fields";
import i18n from "@/i18n";

export default {
    namespaced: true,
    state: {
        fetched: false,
        goods_reserves: null,
    },
    getters: {
        getField, //vuex-map-fields
    },
    mutations: {
        updateField, //vuex-map-fields
    },
    actions: {
        async removeGoodsReserve({ commit, state, dispatch }, payload) {
            updateField(state, {path: 'isLoading', value: true});
            return await this._vm.$confirm( {
                title : this._vm.i18n.t('common.confirm'),
                text : this._vm.i18n.t('common.confirm_remove'),
                cancelText : this._vm.i18n.t('common.no'),
                acceptText : this._vm.i18n.t('common.yes')
            } ).then( async y =>{
                return await axios.delete(this._vm.$apiURL+'/goods_reserves_item/'+payload.type+'/'+payload.id)
                    .then(response => {
                        if(response.data.status==='success'){
                            return true
                        }
                    })
                    .catch(error => {
                        dispatch('common/showError', {'error': error}, {root:true});
                    });
            }).catch( n => {} );
        },
        async fetchGoodsReserves({ commit, state, dispatch }, payload) {
            updateField(state, {path: 'fetched', value: false});
            updateField(state, {path: 'goods_reserves', value: null});
            return await axios
                .post(this._vm.$apiURL + `/goods_reserves_items`, payload)
                .then((response) => {
                    updateField(state, {path: 'goods_reserves', value: response.data.data});
                })
                .catch((error) => {
                    dispatch("common/showError", { error: error }, { root: true });
                })
                .finally(() => {
                    updateField(state, {path: 'fetched', value: true});
                });
        },
        async reserveGoods({ commit, state, dispatch }, payload) {
            updateField(state, {path: 'fetched', value: false});
            updateField(state, {path: 'goods_reserves', value: null});
            return await axios
                .post(this._vm.$apiURL + `/goods_reserve`, payload)
                .then((response) => {
                    updateField(state, {path: 'goods_reserves', value: response.data.data});
                })
                .catch((error) => {
                    dispatch("common/showError", { error: error }, { root: true });
                })
                .finally(() => {
                    updateField(state, {path: 'fetched', value: true});
                });
        },
    },
};
